import { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";

const ColorPicker = ({ layers_name, font_color, index, handleColor }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [color, setColor] = useState({ r: 250, g: 212, b: 220 });

  useEffect(() => {
    // console.log(font_color);
    if (layers_name.indexOf("bg_color") === 0) {
      // console.log("#" + font_color.split("#")[1]);

      if (font_color.includes("#")) {
        setColor("#" + font_color.split("#")[1]);
      } else {
        setColor("#" + font_color);
      }
    } else if (layers_name.indexOf("bgTheme") === 0) {
      var new_bg_color = font_color.split(",");

      console.log(new_bg_color);

      setColor({
        r: new_bg_color[0],
        g: new_bg_color[1],
        b: new_bg_color[2],
        a: new_bg_color[3],
      });
    } else {
      console.log(font_color);
      var new_color = font_color.split(",");

      // console.log(new_color, font_color);

      setColor({ r: new_color[0], g: new_color[1], b: new_color[2] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [font_color]);

  const styles = reactCSS({
    default: {
      color: {
        width: "100%",
        height: "100%",
        borderRadius: "2px",
        background:
          layers_name === "bgTheme"
            ? `rgba(${color.r}, ${color.g}, ${color.b},${color.a})`
            : `rgba(${color.r}, ${color.g}, ${color.b})`,
      },
      swatch: {
        padding: "5px",
        background: "#fff",
        borderRadius: "1px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
        display: "inline-block",
        cursor: "pointer",
      },
      popover: {
        position: "absolute",
        zIndex: "2",
      },
      cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
      },
    },
  });

  const handleChange = (new_color) => {
    // console.log(new_color);
    // console.log(layers_name.indexOf("bg_color"));

    if (layers_name.indexOf("bg_color") === 0) {
      // console.log(new_color.hex);
      setColor(new_color.hex);
    } else {
      // console.log(new_color.rgb);

      setColor(new_color.rgb);
    }
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
    if (layers_name.indexOf("bg_color") === 0) {
      handleColor(layers_name, index, color);
    } else if (layers_name.indexOf("bgTheme") === 0) {
      handleColor(
        layers_name,
        index,
        `${color.r},${color.g},${color.b},${color.a}`
      );
    } else {
      handleColor(layers_name, index, `${color.r},${color.g},${color.b}`);
    }
  };

  return (
    <div>
      <div
        style={styles.swatch}
        onClick={(e) => {
          setDisplayColorPicker(!displayColorPicker);
        }}
        className="form-control"
      >
        {layers_name.indexOf("bg_color") === 0 ? (
          <div
            className="a"
            style={{
              backgroundColor: `${color}`,
              width: "100%",
              height: "100%",
              borderRadius: "2px",
            }}
          />
        ) : (
          <div style={styles.color} />
        )}
      </div>
      {displayColorPicker ? (
        <div style={styles.popover}>
          <div style={styles.cover} onClick={handleClose} />
          <SketchPicker
            color={color}
            disableAlpha={layers_name === "bgTheme" ? false : true}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ColorPicker;
